var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.509 19.1468L14.0929 2.70744C12.9412 0.697536 11.059 0.697536 9.90756 2.70744L0.491472 19.1468C-0.65994 21.1588 0.282038 22.8 2.58326 22.8H21.4171C23.7184 22.8 24.6594 21.1587 23.509 19.1468ZM10.7069 7.37194C11.0453 7.00316 11.4755 6.81873 12.0001 6.81873C12.525 6.81873 12.9548 7.00121 13.2935 7.36457C13.63 7.72874 13.7982 8.18418 13.7982 8.73184C13.7982 9.20304 13.0958 12.668 12.8615 15.1887H11.1697C10.9642 12.6679 10.202 9.20304 10.202 8.73184C10.2021 8.19249 10.3706 7.73893 10.7069 7.37194ZM13.2698 19.3581C12.9139 19.7075 12.4904 19.8816 12.0002 19.8816C11.5102 19.8816 11.0865 19.7075 10.7307 19.3581C10.3758 19.0095 10.1994 18.5872 10.1994 18.0913C10.1994 17.598 10.3758 17.1711 10.7307 16.8134C11.0865 16.4556 11.5102 16.2766 12.0002 16.2766C12.4904 16.2766 12.9139 16.4556 13.2698 16.8134C13.6245 17.1711 13.8013 17.598 13.8013 18.0913C13.8013 18.5872 13.6245 19.0095 13.2698 19.3581Z",
    fill: "#E71111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f40018281e4d132bb339e143a0735546.svg";
export { ForwardRef as ReactComponent };